import React, { useState } from 'react';
import { Form } from 'reactstrap';
import { Box, Modal, Typography, TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { styled } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import moment from 'moment';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 500,
  width: 800,
  bgcolor: 'background.paper',
  border: '1px solid #59b9ea',
  borderColor: 'primary.light',
  boxShadow: 24,
  p: 3,
};
const CssSelect = styled(Select)({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#00000',
  },
  '& .MuiInputBase-input': {
    WebkitTextFillColor: 'green',
    color: 'red',
  },
});

// const initialFieldValues = {
//   purchaseId: 0,
//   purCodeNo: '',
//   purSaupJaNo: '',
//   purSangHo: '',
//   purUpJong: '',
//   purDaePyo: '',
//   purDaePyoPhone: '',
//   purFax: '',
//   purDamDangJaPhone: '',
//   purDamDangJaName: '',
//   purSaUpJangJuSo: '',
//   purJaJeGuBun: '',
//   purDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
//   purUser: ''
// }


function PurchaseEdit(props) {
  const { addOrEdit } = props
  const [purchaseId] = useState(props.purchaseEditValue.Id) //구매업체 Id
  const [purCodeNo, setPurCodeNo] = useState(props.purchaseEditValue.s_업체코드) //업체코드 
  const [purSangHo, setPurSangHo] = useState(props.purchaseEditValue.s_업체상호) //업체상호
  const [purSaupJaNo, setPurSaupJaNo] = useState(props.purchaseEditValue.s_업체사업자번호) //사업자번호
  const [purUpJong, setPurUpJong] = useState(props.purchaseEditValue.s_업체업종) //업종
  const [purDaePyoJaName, setPurDaePyoJaName] = useState(props.purchaseEditValue.s_대표자성명) //대표자성명
  const [purDaePyoJaPhone, setDaePyoJaPhone] = useState(props.purchaseEditValue.s_대표자전화) //대표자전화
  const [purDaePyoPhone, setDaePyoPhone] = useState(props.purchaseEditValue.s_업체전화) //회사대표전화
  const [purFax, setFax] = useState(props.purchaseEditValue.s_업체팩스)
  const [purDamDangJaPhone, setPurDamDangJaPhone] = useState(props.purchaseEditValue.s_업체관리자전화)
  const [purDamDangJaName, setPurDamDangJaName] = useState(props.purchaseEditValue.s_업체관리자성명)
  const [purJichulsummery, setPurJichulsummery] = useState(props.purchaseEditValue.s_지출내역) //구매지출요약
  const [purJichulBank, setPurJichulBank] = useState(props.purchaseEditValue.s_은행명) //구매지출은행
  const [purJichulBankNo, setPurJichulBankNo] = useState(props.purchaseEditValue.s_계좌번호) //구매지출은행계좌번호
  const [purJichulBankName, setPurJichulBankName] = useState(props.purchaseEditValue.s_예금주) //구매지출은행예금주명
  const [purSaUpJangJuSo, setPurSaUpJangJuSo] = useState(props.purchaseEditValue.s_업체주소)
  const [purJaJeGuBun, setPurJaJeGuBun] = useState(props.purchaseEditValue.s_업무구분)
  const [purJaJeBulChul, setPurJaJeBulChul] = useState(props.purchaseEditValue.s_업체자재불출유무)
  const [purJaJeUpcheYesNo, setPurJaJeUpcheYesNo] = useState(props.purchaseEditValue.s_사용유무) //업체사용유무

  //업체코드
  let purCodeNoHandle = (e) => {
    e.preventDefault();
    setPurCodeNo(e.target.value);
  };
  //업체상호
  let purSanghoHandle = (e) => {
    e.preventDefault();
    setPurSangHo(e.target.value);
  };
  //사업자번호
  let purSaupJaNoHandle = (e) => {
    e.preventDefault();
    setPurSaupJaNo(e.target.value);
  };
  //업종
  let purUpJongHandle = (e) => {
    e.preventDefault();
    setPurUpJong(e.target.value);
  };
  //대표자성명
  let purDaePyoJaNameHandle = (e) => {
    e.preventDefault();
    setPurDaePyoJaName(e.target.value);
  };
  //업체대표자전화
  let purDaePyoJaPhoneHandle = (e) => {
    e.preventDefault();
    setDaePyoJaPhone(e.target.value);
  };
  //업체대표전화
  let purDaePyoPhoneHandle = (e) => {
    e.preventDefault();
    setDaePyoPhone(e.target.value);
  };
  //대표팩스
  let purFaxHandle = (e) => {
    e.preventDefault();
    setFax(e.target.value);
  };
  //담당자전화
  let purDamDangJaPhoneHandle = (e) => {
    e.preventDefault();
    setPurDamDangJaPhone(e.target.value);
  };
  //담당자전화
  let purDamDangJaNameHandle = (e) => {
    e.preventDefault();
    setPurDamDangJaName(e.target.value);
  };
  //업체구매정보 지출내역요약
  let purJichulsummeryHandle = (e) => {
    e.preventDefault();
    setPurJichulsummery(e.target.value);
  };
  //업체구매정보 지출은행
  let purJichulBankHandle = (e) => {
    e.preventDefault();
    setPurJichulBank(e.target.value);
  };
  //업체구매정보 지출은행계좌번호
  let purJichulBankNoHandle = (e) => {
    e.preventDefault();
    setPurJichulBankNo(e.target.value);
  };
  //업체구매정보 지출은행예금주명
  let purJichulBankNameHandle = (e) => {
    e.preventDefault();
    setPurJichulBankName(e.target.value);
  };
  //사업장 주소
  let purSaUpJangJuSoHandle = (e) => {
    e.preventDefault();
    setPurSaUpJangJuSo(e.target.value);
  };

  //자재구분
  let purJaJeGuBunHandle = (e) => {
    e.preventDefault();
    setPurJaJeGuBun(e.target.value);
  };

  //Osp자재출출유무
  let purJaJeBulChulHandle = (e) => {
    e.preventDefault();
    setPurJaJeBulChul(e.target.value);
  };

   //업체사용유무
   let purJaJeUpcheYesNoHandle = (e) => {
    e.preventDefault();
    setPurJaJeUpcheYesNo(e.target.value);
  };

  //수정버튼 전송실행
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData()
    formData.append('Id', purchaseId)
    formData.append('s_업체코드', purCodeNo)
    formData.append('s_업체상호', purSangHo)
    formData.append('s_업체사업자번호', purSaupJaNo)
    formData.append('s_업체업종', purUpJong)
    formData.append('s_대표자성명', purDaePyoJaName)
    formData.append('s_대표자전화', purDaePyoJaPhone)
    formData.append('s_업체전화', purDaePyoPhone)
    formData.append('s_업체팩스', purFax)
    formData.append('s_업체관리자전화', purDamDangJaPhone)
    formData.append('s_업체관리자성명', purDamDangJaName)
    formData.append('s_지출내역', purJichulsummery)
    formData.append('s_은행명', purJichulBank)
    formData.append('s_계좌번호', purJichulBankNo)
    formData.append('s_예금주', purJichulBankName)
    formData.append('s_업체주소', purSaUpJangJuSo)
    formData.append('s_업무구분', purJaJeGuBun)
    formData.append('s_업체자재불출유무', purJaJeBulChul)
    formData.append('s_사용유무', purJaJeUpcheYesNo)
    formData.append('s_등록일자', moment().format('YYYY-MM-DD HH:mm'))
    formData.append('s_등록자', props.urlpw)

    formData.append('s_code', purCodeNo)
    formData.append('s_name', purSangHo)
    formData.append('s_date', moment().format('YYYY-MM-DD HH:mm'))
    formData.append('s_user', props.urlpw)
    addOrEdit(formData)
    props.setPurchaseEditModal(false);
  }

  // //초기화
  // const resetForm = (e) => {
  //   setValues(initialFieldValues)
  //   document.getElementById('purchase-uploader').value = null;
  //   // setErrors({})
  // }

  return (
    <div>
      <Modal open={props.purchaseEditModal}>
        <Box sx={style}>
          <div>
            <Typography
              id="modal-modal-titledlq"
              style={{
                fontFamily: 'D2Coding',
                fontSize: '24px',
                color: 'green',
              }}
            >
              구매업체수정
            </Typography>
          </div>

          <Form onSubmit={handleSubmit}>
            <div>
              <div>
                <TextField
                  disabled
                  onChange={purCodeNoHandle}
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purCodeNo === '' ? { shrink: false } : { shrink: true }
                  }
                  id=""
                  label="업체코드"
                  name="purCodeNo"
                  size="small"
                  value={purCodeNo ? purCodeNo : ''}
                />
              </div>
              <div>
                <TextField
                  required //필수등록
                  onChange={purSanghoHandle}
                  style={{ width: 200, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purSangHo === '' ? { shrink: false } : { shrink: true }
                  }
                  label="업체상호"
                  name="sangho"
                  size="small"
                  value={purSangHo ? purSangHo : ''}
                />
                <TextField
                  required //필수등록
                  onChange={purSaupJaNoHandle}
                  style={{ width: 200, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purSaupJaNo === '' ? { shrink: false } : { shrink: true }
                  }
                  label="사업자번호"
                  name="sangho"
                  size="small"
                  value={purSaupJaNo ? purSaupJaNo : ''}
                />
                <TextField
                  required //필수등록
                  onChange={purUpJongHandle}
                  style={{ width: 200, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purUpJong === '' ? { shrink: false } : { shrink: true }
                  }
                  label="업종"
                  name="purUpJong"
                  size="small"
                  value={purUpJong ? purUpJong : ''}
                />
              </div>
              <div>
                <TextField
                  //required //필수등록
                  onChange={purDaePyoJaNameHandle}
                  style={{ width: 200, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purDaePyoJaName === '' ? { shrink: false } : { shrink: true }
                  }
                  label="대표자성명"
                  name="purupJong"
                  size="small"
                  value={purDaePyoJaName ? purDaePyoJaName : ''}
                />
                <TextField
                  // required //필수등록
                  onChange={purDaePyoJaPhoneHandle}
                  style={{ width: 200, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purDaePyoJaPhone === '' ? { shrink: false } : { shrink: true }
                  }
                  label="대표자메일"
                  name="purDaePyoPhone"
                  size="small"
                  value={purDaePyoJaPhone ? purDaePyoJaPhone : ''}
                />
              </div>
              <div>
                <TextField
                  //required //필수등록
                  onChange={purDaePyoPhoneHandle}
                  style={{ width: 200, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purDaePyoPhone === '' ? { shrink: false } : { shrink: true }
                  }
                  label="업체대표전화"
                  name="purDaePyoPhone"
                  size="small"
                  value={purDaePyoPhone ? purDaePyoPhone : ''}
                />
                <TextField
                  //required //필수등록
                  onChange={purFaxHandle}
                  style={{ width: 200, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purFax === '' ? { shrink: false } : { shrink: true }
                  }
                  label="업체팩스"
                  name="purFax"
                  size="small"
                  value={purFax ? purFax : ''}
                />
              </div>
              <div>
                <TextField
                  //required //필수등록
                  onChange={purDamDangJaPhoneHandle}
                  style={{ width: 200, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purDamDangJaPhone === '' ? { shrink: false } : { shrink: true }
                  }
                  label="업체담당자전화"
                  name="purDamDangJaPhone"
                  size="small"
                  value={purDamDangJaPhone ? purDamDangJaPhone : ''}
                />
                <TextField
                  //required //필수등록
                  onChange={purDamDangJaNameHandle}
                  style={{ width: 200, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purDamDangJaName === '' ? { shrink: false } : { shrink: true }
                  }
                  label="업체담당자성명"
                  name="purDamDangJaPhone"
                  size="small"
                  value={purDamDangJaName ? purDamDangJaName : ''}
                />
              </div>
              <div>
              <TextField
                  //required //필수등록
                  onChange={purJichulsummeryHandle}
                  style={{ width: 150, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purJichulsummery === '' ? { shrink: false } : { shrink: true }
                  }
                  label="지출요약"
                  name="purJichulsummery"
                  size="small"
                  value={purJichulsummery ? purJichulsummery : ''}
                />
              <TextField
                  //required //필수등록
                  onChange={purJichulBankHandle}
                  style={{ width: 150, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purJichulBank === '' ? { shrink: false } : { shrink: true }
                  }
                  label="지출은행"
                  name="purJichulBank"
                  size="small"
                  value={purJichulBank ? purJichulBank : ''}
                />
              <TextField
                  //required //필수등록
                  onChange={purJichulBankNoHandle}
                  style={{ width: 200, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purJichulBankNo === '' ? { shrink: false } : { shrink: true }
                  }
                  label="지출계좌번호"
                  name="purJichulBankNo"
                  size="small"
                  value={purJichulBankNo ? purJichulBankNo : ''}
                />
              <TextField
                  //required //필수등록
                  onChange={purJichulBankNameHandle}
                  style={{ width: 150, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purJichulBankName === '' ? { shrink: false } : { shrink: true }
                  }
                  label="예금주명"
                  name="purJichulBankName"
                  size="small"
                  value={purJichulBankName ? purJichulBankName : ''}
                />
              </div>
              <div>
                <TextField
                  required //필수등록
                  onChange={purSaUpJangJuSoHandle}
                  style={{ width: 700, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    purSaUpJangJuSo === '' ? { shrink: false } : { shrink: true }
                  }
                  label="업체사업장주소"
                  name="purSaUpJangJuSo"
                  size="small"
                  value={purSaUpJangJuSo ? purSaUpJangJuSo : ''}
                />
              </div>
              <div>
                <FormControl
                  required
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  size="small"
                >
                  <InputLabel id="demo-simple-select-autowidth-label">
                    자재구분
                  </InputLabel>
                  <CssSelect
                    variant="outlined"
                    value={purJaJeGuBun ? purJaJeGuBun : ''}
                    onChange={purJaJeGuBunHandle}
                    label="자재구분"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={'식비자재'}>식비자재</MenuItem>
                    <MenuItem value={'소모자재'}>소모자재</MenuItem>
                    <MenuItem value={'전기자재'}>전기자재</MenuItem>
                    <MenuItem value={'화학자재'}>화학자재</MenuItem>
                    <MenuItem value={'접착자재'}>접착자재</MenuItem>
                    <MenuItem value={'수불자재'}>수불자재</MenuItem>
                    <MenuItem value={'내부거래'}>내부거래</MenuItem>
                    <MenuItem value={'사급자재'}>사급자재</MenuItem>
                    <MenuItem value={'일반자재'}>일반자재</MenuItem>
                    <MenuItem value={'기타자재'}>기타자재</MenuItem>
                  </CssSelect>
                </FormControl>
                <FormControl
                  required
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  size="small"
                >
                  <InputLabel id="demo-simple-select-autowidth-label">
                    Osp불출유무
                  </InputLabel>
                  <CssSelect
                    variant="outlined"
                    value={purJaJeBulChul ? purJaJeBulChul : ''}
                    onChange={purJaJeBulChulHandle}
                    label="Osp불출유무"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={'Yes'}>Yes</MenuItem>
                    <MenuItem value={'No'}>No</MenuItem>
                  </CssSelect>
                </FormControl>
                <FormControl
                  required
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '8px', float: 'center', marginRight: '2px', }}
                  size="small"
                >
                  <InputLabel id="demo-simple-select-autowidth-label">
                    업체사용YesNo
                  </InputLabel>
                  <CssSelect
                    variant="outlined"
                    value={purJaJeUpcheYesNo}
                    onChange={purJaJeUpcheYesNoHandle}
                    label="업체사용YesNo"
                  >
                    <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem>
                    <MenuItem value={'Yes'}>Yes</MenuItem>
                    <MenuItem value={'No'}>No</MenuItem>
                  </CssSelect>
                </FormControl>
              </div>
            </div>
            <div style={{ marginTop: '10px' }}>
              <Button
                // onClick={handleSubmit}
                type="submit"
                startIcon={<SaveIcon />}
                variant="contained"
                style={{
                  height: '37px',
                  background: '#388e3c',
                  color: 'white',
                  width: 100,
                  marginRight: '2px',
                  float: 'center',
                }}
              >
                수정
              </Button>
              <Button
                onClick={() => {
                  props.setPurchaseEditModal(false);
                }}
                variant="contained"
                startIcon={<CloseIcon />}
                style={{
                  height: '37px',
                  width: 100,
                  background: '#689f38',
                  color: 'white',
                  marginTop: '2px',
                  float: 'center',
                }}
              >
                나가기
              </Button>
            </div>
          </Form>
        </Box>
      </Modal>
    </div>
  );
}

export default PurchaseEdit;
